import angular from 'angular';

import isNumber from './isNumber';
import isPrice from './isPrice';
import googleAutocomplete from './googleAutocomplete';

const directivesModule = angular.module('tinaba.directives', [
  isNumber.name,
  isPrice.name,
  googleAutocomplete.name
]);

export default directivesModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/directives/directives.js
 **/